import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { StatusCodes } from "http-status-codes";
async function fetch(args: any, api: any, extraOptions: any) {
  const result = await fetchBaseQuery({
    baseUrl: "https://admin-school.azno.co/apiv1/",
    credentials: "include",
  })(args, api, extraOptions);
  if (result.error && result.error.status === StatusCodes.UNAUTHORIZED) {
    window.location.href = "/login";
  }
  return result;
}
export const api = createApi({
  baseQuery: fetch,
  endpoints: (builder) => ({}),
  tagTypes: [
    "users",
    "members",
    "organs",
    "organs-courses",
    "banners",
    "categories",
    "courses",
    "snacks",
    "files",
    "quizes",
    "questions",
    "practices",
  ],
});
